import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Chat } from '../models/chat.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { map } from 'rxjs/operators';
import { LogModel } from '../models/log-model.model';
import { ChatNoLeidos } from '../models/chatnoleidos.model';
import { Archivo } from '../models/archivo.model';
import { ChatSelected } from '../models/chatSelected.model';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  readonly apiUrlService = environment.apiUrl;
  chatsNoLeidos$: Subject<ChatNoLeidos[]> = new Subject();
  chats$: Subject<Chat[]> = new Subject();
  chat$: Subject<Chat> = new Subject();
  private selectedReferenceSubject = new BehaviorSubject<ChatSelected | null>(null);
  selectedReference$ = this.selectedReferenceSubject.asObservable();

  constructor(private http: HttpClient, private authService: AuthenticationService) { }

  // Función para actualizar la referencia seleccionada
  public selectReference(reference: ChatSelected): void {
    this.selectedReferenceSubject.next(reference);
  }

  getChats$(): Observable<Chat[]> {
    return this.chats$.asObservable();
  }

  getChatsNoLeidos$(): Observable<ChatNoLeidos[]> {
    return this.chatsNoLeidos$.asObservable();
  }

  getChat$(): Observable<Chat> {
    return this.chat$.asObservable();
  }

  setChat$(chat: Chat) {
    this.chat$.next(chat);
  }

  getAllChatsNoLeidos() {
    const url_api = this.apiUrlService + "envios_chat";
    var headersToken: HttpHeaders = new HttpHeaders({
      "Authorization": "Bearer " + this.authService.getToken()
    })
    this.http.get(url_api, { headers: headersToken })
      .pipe(map(data => data as ChatNoLeidos[]))
      .subscribe(ch => {
        this.chatsNoLeidos$.next(ch);
      });
  }

  getChats(selectedReference: ChatSelected) {
    const url_api = this.apiUrlService + "envios_chat/" + selectedReference.type + "/" + selectedReference.codigo.replace('E', '');
    var headersToken: HttpHeaders = new HttpHeaders({
      "Authorization": "Bearer " + this.authService.getToken()
    })
    this.http.get(url_api, { headers: headersToken })
      .pipe(map(data => data as Chat[]))
      .subscribe(ch => {
        this.chats$.next(ch);
      });
  }
  
  marcarChatsComoLeido(selectedReference: ChatSelected) {
    const url_api = this.apiUrlService + "envios_chat/" + selectedReference.type + "/" + selectedReference.codigo.replace('E', '') + "/leido";
    var headersToken: HttpHeaders = new HttpHeaders({
      "Authorization": "Bearer " + this.authService.getToken()
    })
    this.http.post(url_api, null, { headers: headersToken })
      .pipe(map(data => data as boolean))
      .subscribe(ch => {
      });
  }

  sendMenssage(chatPost: Chat, log: LogModel): Observable<boolean> {
    const url_api = this.apiUrlService + "envios_chat";
    var headersToken: HttpHeaders = new HttpHeaders({
      "Authorization": "Bearer " + this.authService.getToken(),
      "Content-Type": "application/json"
    })
    return this.http.post(url_api, JSON.stringify({ "Log": log, "Body": JSON.stringify(chatPost) }), { headers: headersToken })
      .pipe(map(data => data as boolean));
  }

  deleteChat(idChat: number): Observable<boolean> {
    const url_api = this.apiUrlService + "envios_chat/" + idChat;
    var headersToken: HttpHeaders = new HttpHeaders({
      "Authorization": "Bearer " + this.authService.getToken()
    })
    return this.http.delete(url_api, { headers: headersToken })
      .pipe(map(data => data as boolean));
  }

  descargarFichero(codigoChat: number): Observable<Archivo> {
    const url_api = this.apiUrlService + "envios_chat/descargar/" + codigoChat;
    const headersToken: HttpHeaders = new HttpHeaders({
      Authorization: "Bearer " + this.authService.getToken(),
    });

    return this.http.get(url_api, { headers: headersToken }).pipe(map(a => a as Archivo));
  }
}
